import { getBoolOrFalse } from "./regDataBool";

export interface DrRegDataComparisonRowProps {
    displayCode: string;
    isForReceipt: boolean;
    isForRemoval: boolean;
    /** When "below", description renders under the code line in muted text. */
    descriptionPlacement?: "inline" | "below";
    displayDescription?: string;
    /** When true, membership suffix uses pending-change colour instead of muted. */
    pendingChange?: boolean;
}

export function formatDrMembershipLabels(isForReceipt: boolean, isForRemoval: boolean): string[] {
    const labels: string[] = [];
    if (isForReceipt) labels.push("Received");
    if (isForRemoval) labels.push("Removed");
    return labels;
}

export function DrMembershipFlagSuffix({
    isForReceipt,
    isForRemoval,
    pendingChange = false,
}: {
    isForReceipt: boolean;
    isForRemoval: boolean;
    pendingChange?: boolean;
}) {
    const labels = formatDrMembershipLabels(isForReceipt, isForRemoval);
    if (labels.length === 0) {
        return null;
    }

    return <span className={pendingChange ? "" : "text-muted"}> | {labels.join(" | ")}</span>;
}

export function DrRegDataComparisonRow({
    displayCode,
    isForReceipt,
    isForRemoval,
    descriptionPlacement = "inline",
    displayDescription,
    pendingChange = false,
}: DrRegDataComparisonRowProps) {
    const codeText = displayCode.trim() || "—";

    const codeLine = (
        <div>
            <span>{codeText}</span>
            <DrMembershipFlagSuffix
                isForReceipt={isForReceipt}
                isForRemoval={isForRemoval}
                pendingChange={pendingChange}
            />
        </div>
    );

    if (descriptionPlacement === "below" && displayDescription?.trim()) {
        return (
            <div className="small">
                {codeLine}
                <div className="text-muted">{displayDescription}</div>
            </div>
        );
    }

    return <div className="small">{codeLine}</div>;
}

export function drFlagsFromParsed(parsed: Record<string, unknown> | undefined): {
    isForReceipt: boolean;
    isForRemoval: boolean;
} {
    return {
        isForReceipt: getBoolOrFalse(parsed, "isForReceipt"),
        isForRemoval: getBoolOrFalse(parsed, "isForRemoval"),
    };
}
